import React, { useEffect, useState } from "react";
import { Cookies } from "../../index.js";
import { alert_error, alert_success, copy_native } from "../../AppContext";

const codeSnippets = {
  loading: "Dang tai",
  getJobs: `GET api:
{Url_Main}/jop/tiktok/get_jop.php?api_key={API_KEY}&chedo={mode}&national_market={vi|en}
Mode:
- tiktok
- twitter
- youtube
- googlemaps

Response:
{
  "status": 1,
  "datajop": [...],
  "money": "...",
  "idtiktokjop": "..."
}`,
  startCheck: `POST api:
{Url_Main}/jop/startcheck.php
json Post:
{
  "idlink": "{idlink}",
  "taskId": "{taskId}",
  "chedo": "{tiktoklike|tiktokfol|...}"
}

Response:
{
  "status": 1
}`,
  checkCommon: `POST api:
{Url_Main}/jop/tiktok/tiktok_check.php
json Post (follow/video/comment):
{
  "key": "{API_KEY}",
  "service": "{follow|video|comment}",
  "lienketjop": "{url_or_id}",
  "id_service": "{id_service}"
}

json Post (pro non-like):
{
  "key": "{API_KEY}",
  "url": "{lienketjop}",
  "idlinka": "{idlink}",
  "idzad": "{taskId}",
  "idclana": "{code3}",
  "chedo": "{tiktokfol|...}"
}

Response:
{
  "status": 1,
  "order": "..."
}`,
  checkLikePro: `POST api:
{Url_Main}/jop/tiktok/checktim.php
json Post (pro + tiktoklike):
{
  "key": "{API_KEY}",
  "url": "{lienketjop}",
  "idlinka": "{idlink}",
  "idzad": "{taskId}",
  "idclana": "{code3}",
  "chedo": "tiktoklike"
}

Response:
{
  "status": 1,
  "order": "..."
}`,
  notes: `Notes:
- tiktok_check.php duoc dung cho follow / video / comment va pro non-like.
- checktim.php duoc dung rieng cho pro + tiktoklike.
- Neu response.status != 1, frontend se show response.error va load lai danh sach.`,
};

export default function Api_docs({ category = "sub4sub_tiktok" }) {
  const [api_lists, set_api_lists] = useState([
    {
      title: "Loading",
      snippet: codeSnippets.loading,
      bg: "bg-pink-200",
      preTextColor: "text-gray-900",
    },
  ]);

  const myCookieValue = Cookies.get("apikey");
  const urlMain = typeof window !== "undefined" ? window.location.origin : "{Url_Main}";

  useEffect(() => {
    if (category === "sub4sub_tiktok") {
      set_api_lists([
        { title: "Get jobs list", snippet: codeSnippets.getJobs, bg: "bg-pink-200", preTextColor: "text-gray-900" },
        { title: "Start check", snippet: codeSnippets.startCheck, bg: "bg-pink-200", preTextColor: "text-gray-900" },
        { title: "Check follow/video/comment", snippet: codeSnippets.checkCommon, bg: "bg-pink-200", preTextColor: "text-gray-900" },
        { title: "Check tim (pro)", snippet: codeSnippets.checkLikePro, bg: "bg-pink-200", preTextColor: "text-gray-900" },
        { title: "Notes", snippet: codeSnippets.notes, bg: "bg-pink-50", preTextColor: "text-pink-700" },
      ]);
      return;
    }

    set_api_lists([
      { title: "Get jobs list", snippet: codeSnippets.getJobs, bg: "bg-pink-200", preTextColor: "text-gray-900" },
      { title: "Check follow/video/comment", snippet: codeSnippets.checkCommon, bg: "bg-pink-200", preTextColor: "text-gray-900" },
      { title: "Check tim (pro)", snippet: codeSnippets.checkLikePro, bg: "bg-pink-200", preTextColor: "text-gray-900" },
      { title: "Notes", snippet: codeSnippets.notes, bg: "bg-pink-50", preTextColor: "text-pink-700" },
    ]);
  }, [category]);

  function copyText(value) {
    if (!value) {
      alert_error?.("No text to copy");
      return;
    }
    copy_native(value);
    alert_success?.("Copied to clipboard");
  }

  function openSupport() {
    if (typeof window !== "undefined") {
      window.open("https://t.me/hustmedia", "_blank");
    }
  }

  return (
    <>
      <div className="mt-2 mx-2 sm:mx-4">
        <div className="mx-auto max-w-xl sm:max-w-2xl">
          <form className="add-form">
            <div className="form-control">
              <div className="bg-white shadow-sm rounded-xl overflow-hidden mb-2 mt-1 border border-gray-100">
                <div className="px-2 py-0 mt-1">
                  <div className="text-2xl font-semibold text-gray-800">API Docs</div>
                  <div className="mt-0 text-sm text-gray-600">
                    Shortcuts & examples for talking to the API. Tap{" "}
                    <span className="font-semibold">Copy</span> to copy the JSON/params.
                  </div>
                </div>
                <div className="rounded-xl overflow-hidden">
                  <div className="flex justify-between items-center py-1 mx-2 border-t border-gray-200">
                    <span className="text-sm text-pink-500">HTTPs Method</span>
                    <span className="inline-block bg-indigo-100 text-indigo-700 font-semibold px-3 py-1 rounded-full text-sm">
                      POST, GET
                    </span>
                  </div>

                  <div className="flex justify-between items-center py-1 mx-2 border-t border-gray-200">
                    <span className="text-sm text-pink-500">{`{Url_Main}`}</span>
                    <code className="inline-block bg-gray-100 text-gray-800 px-3 py-1 rounded-lg select-all text-sm">
                      {urlMain}
                    </code>
                  </div>

                  <div className="flex justify-between items-center py-1 mx-2 border-t border-gray-200">
                    <span className="text-sm text-pink-500">{`{API_URL}`}</span>
                    <code className="inline-block bg-gray-100 text-gray-800 px-3 py-1 rounded-lg select-all text-sm">
                      {`${urlMain}/jop/tiktok`}
                    </code>
                  </div>

                  <div className="flex w-full">
                    <div className="flex-1 p-1 mx-2 font-mono text-sm break-all text-gray-800 border-t border-r border-gray-200">
                      <div className="text-sm text-pink-500">Your {"{API_KEY}"}</div>
                      <div className="mt-1 text-sm">{myCookieValue || "********************"}</div>
                    </div>

                    <div className="flex-1 p-1 mx-2 text-sm border-t border-gray-200">
                      <div className="text-sm text-pink-500">Response format</div>
                      <div className="mt-1 font-semibold">JSON</div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                {api_lists.map((b, idx) => (
                  <div key={idx} className="rounded-xl overflow-hidden border border-transparent">
                    <div className={`flex items-center justify-between p-2 ${b.bg} bg-opacity-80 shadow-md rounded-t-xl`}>
                      <div className="flex items-start">
                        <div className="mr-3 mt-0.5">
                          <span className="inline-block w-3 h-3 rounded-full ring-2 ring-white/70" />
                        </div>
                        <div>
                          <div className="text-sm font-semibold text-gray-800">{b.title}</div>
                          <div className="text-xs text-gray-600">Json or Param for API</div>
                        </div>
                      </div>

                      <div className="flex items-center space-x-2">
                        <button
                          type="button"
                          className="inline-flex items-center text-xs font-medium px-3 py-1.5 rounded-lg bg-blue-600 hover:bg-blue-700 text-white focus:outline-none focus:ring-2 focus:ring-blue-200 shadow-sm active:scale-95 transition"
                          onClick={() => copyText(b.snippet)}
                        >
                          Copy
                        </button>

                        <button
                          type="button"
                          className="inline-flex items-center text-xs font-medium px-3 py-1.5 rounded-lg bg-white/90 hover:bg-white text-gray-800 border border-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-100 shadow-sm active:scale-95 transition"
                          onClick={openSupport}
                        >
                          Support
                        </button>
                      </div>
                    </div>

                    <div className={`p-3 ${b.bg} border-t border-gray-800 rounded-b-xl`} style={{ boxShadow: "0 6px 18px rgba(12,12,15,0.04)" }}>
                      <pre
                        className={`whitespace-pre-wrap ${b.preTextColor} text-sm leading-6 font-mono`}
                        style={{ overflowX: "auto", margin: 0, maxHeight: 340, WebkitOverflowScrolling: "touch" }}
                      >
                        {b.snippet}
                      </pre>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </form>
        </div>
      </div>
      <br />
    </>
  );
}
